import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FooterComponent, HeaderComponent, SidebarComponent } from '@pragma/components';
import { NgxEchartsDirective, provideEcharts } from 'ngx-echarts';
import { PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import * as elJSON from '../assets/i18n/el.json';
import * as enJSON from '../assets/i18n/en.json';
import { AuthComponent } from './auth/auth.component';
//import { MeasurementSocket } from './core/services/sockets/measurement-socket';
import { ThemeColorSwitcherService } from './core/services/theme/theme-color-switcher.service';
import { Subscription } from 'rxjs';
//import { PubSubService } from './core/services/azure/pub-sub.service';

@Component({
    selector: 'ngx-app',
    standalone: true,
    template: `<router-outlet></router-outlet>`,
    imports: [
        CommonModule,
        RouterModule,
        ToastModule,
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        AuthComponent,
        NgxEchartsDirective
    ],
    providers: [provideEcharts()],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
    private themeSubscription: Subscription = new Subscription();
    isDarkMode: boolean = false;

    constructor(
        private config: PrimeNGConfig,
        private translateService: TranslateService,
        //private socket: MeasurementSocket,
        private _themeColorSwitcherService: ThemeColorSwitcherService,
        //private _pubSubService: PubSubService,
        private _cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.config.setTranslation(elJSON);
        this.translateService.onLangChange.subscribe((event) => {
            if (event.lang === 'el') {
                this.config.setTranslation(elJSON);
            } else {
                this.config.setTranslation(enJSON);
            }
        });

        // NOT WORKING PROPERLY - ToDo: We have to replace Sockets
        // this.socket.on('connect', () => {
        //     if (this.socket.ioSocket.connected) {
        //         //console.log('Socket Connected', this.socket);
        //     }
        // });

        // this.socket.on('connect_error', (err: any) => {
        //     console.log('Socket Error: ', err);
        // });

        this.themeSubscription = this._themeColorSwitcherService.darkModeState.subscribe((isDark) => {
            this.isDarkMode = isDark;
            this._cd.detectChanges();
        });
    }

    ngOnDestroy(): void {
        if (this.themeSubscription) {
            this.themeSubscription.unsubscribe();
            this._cd.detectChanges();
        }
    }
}
